import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { MatDialog } from '@angular/material/dialog';
import { ManikEcommBase } from '../NovaEcomm/ManikEcommBase';
import { NovaBookingHandler } from '../NovaBooking/nova-booking-handler';
import { IProductVariant } from '../models/IProductVariant';
import { map, take, retry } from 'rxjs/operators';
import { ISiteFetchData, ISiteMetaData } from '../models/site-metadata';
declare const google: any;

export class SmartcardSiteBase extends ManikEntityFE {
  public IsEdit: boolean = false;
  public SiteMetaData: string = "";
  public IsWebPageInitialized: boolean = false;
  public IsWebCard: boolean = false;
  public IsSmartSite: boolean = false;
  public WebSiteMetaData: any = {};
  public BusinessID: string;
  public LoadURL: string = location.href;
  public PortalContext: string = "";
  public PortalDS: string = "";
  public BackendURL: string = "";
  public BizHandle: string = "";
  protected NovaEcomm: ManikEcommBase;
  protected BookingStore: NovaBookingHandler;
  public OnDemandDivArray: any[] = [];
  public ProductList: any[] = [];
  public VarientList: IProductVariant[] = [];

  constructor(public httpClient: HttpClient,
    public _routeParams: ActivatedRoute, protected title: Title, public _dialog:MatDialog) {
    super(document);
  }

  public populateControls(): void {
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    let Action = location.pathname.split('/')[1];

    let headers = { headers: new HttpHeaders({ 'BusinessSlug': slug, 'Context': "FETCH.MY.SITE" }) };
    let SitePainter = this.httpClient.post<any>("https://bizbackend.manikworks.com/smartbiz", null, headers).pipe(map(value => value), take(1), retry(3));

    SitePainter.subscribe(data => {
      let resp: ISiteFetchData = data;
      this.SiteMetaData = resp.PageHTML;
      // this.document.getElementById("favicon").setAttribute("href", resp.FaviconURL);
      this.title.setTitle(resp.Title);
      this.BusinessID = resp.BID;
      this.IsWebPageInitialized = true;
      let MetaData: ISiteMetaData = {
        BizLatitude: resp.BizLatitude,
        BizLongitude: resp.BizLatitude,
        PC: resp.PC,
        BackendURL: resp.BackendURL,
        PDS: resp.PDS,
        PID: resp.PID,
        ECommServer: resp.ECommServer,
        COUNTRYID: resp.COUNTRYID,
        EC: resp.EC,
        EOLVIEW: resp.EOLVIEW,
        BID: resp.BID,
        EBID: resp.EBID,
        CID: resp.CID,
        SCID: resp.SCID,
        SubCategoryName: resp.SubCategoryName,
        BizHandle: resp.BizHandle,
        StoreHandle: resp.StoreHandle,
        ECommWorkOffline: resp.ECommWorkOffline
      }
      sessionStorage.setItem("SiteMetaData", JSON.stringify(MetaData));
      this.PortalContext = resp.PC;
      this.PortalDS = resp.PDS;
      this.BackendURL = resp.BackendURL;
      this.StoreHandle = resp.StoreHandle;
      this.BizHandle = resp.BizHandle;
      (resp.IsRTL === "Y") ?
        this.BindCSS("https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css") :
        this.BindCSS("https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css");
      this.WebSiteMetaData = resp;
      this.BindCSS(resp.SITECSS);
      this.BindCSS(resp.BIZCSS);
      this.BindJS(resp.SITEJS);
      this.BindJS("https://www.google.com/recaptcha/api.js?render=AIzaSyBQmHKpdxsRyy-gwR6K1N7CIuOspBvzZn8");
      //this.BindJS("./assets/script/Manik_Tran.js");
      if (resp.EOLVIEW === "WEBCARD") {
        this.IsWebCard = true;
        setTimeout(() => document.getElementById("openModalButton").click(), 5000);
      }
      else {
        this.IsSmartSite = true;
      }
      setTimeout(() => {
        let arr = this.document.getElementsByTagName('manikph');
        for (let i = 0; i < arr.length; i++) {
          let body: any = {};
          body['id'] = arr[i].id;
          body['html'] = arr[i].innerHTML;
          let attributes = arr[i].attributes;
          if (attributes['pgheader']) body['pgheader'] = attributes['pgheader'].value
          if (attributes['targetcontrol']) body['targetcontrol'] = attributes['targetcontrol'].value;
          this.OnDemandDivArray.push(body);
        }
        
        for (let index = arr.length - 1; index >= 0; index--) {
          arr[index].parentNode.removeChild(arr[index]);
        }

        this.BindJS("./assets/script/Smartsite.js");
        if (this.StoreHandle) {
          this.NovaEcomm = new ManikEcommBase(this.httpClient);
          this.NovaEcomm.PopulateOnlineStore();
        }

        if (Action === "edit") {
          this.IsEdit = true;
          // if (decodedToken.role === "BUSINESS.OWNER") {
          this.BindCSS(resp.EDITCSS);
          this.BindJS(resp.EDITJS);
          this.BindJS("./assets/script/smart-site.edit.js");
          this.document.getElementById("hfIsEdit").value = "Y";
          //}
        }

        this.initMap(parseFloat(resp.BizLatitude), parseFloat(resp.BizLongitude));
        this.BindSocialMedia();

        if (this.BizHandle) {
          // this.BookingStore = new NovaBookingHandler(this._manikEntityService, this.document);
         // this.BookingStore.PopulateOnlineBookingStore(this.BizHandle);
          setTimeout(() => {
            this.BindJS("./assets/script/Manik_Booking.js");
          }, 1000);
        }
      }, 100);
      
      this.BindJS("./assets/script/BusinessEnquiery.js");
    });
  }

  initMap(_lat, _long) {
    var position = { lat: _lat, lng: _long };
    var map = new google.maps.Map(document.getElementById('googleMap'), { zoom: 12, center: position });
    var marker = new google.maps.Marker({ position: position, map: map });
  }

  BindSocialMedia() {
    try {
      let portalURL = window.location.href;
      this.document.getElementById("fbShare").setAttribute("href", "https://www.facebook.com/sharer/sharer.php?u=" + portalURL);
      this.document.getElementById("googleShare").setAttribute("href", "https://plus.google.com/share?url=" + portalURL);
      this.document.getElementById("linkeindShare").setAttribute("href", "https://www.linkedin.com/shareArticle?url=" + portalURL);
      this.document.getElementById("lnkTwiter").setAttribute("href", "https://twitter.com/intent/tweet?url=" + portalURL);
    }
    catch (exception) { }
  }
}
